import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../../SvgIcons/CreateIconComponent';

export type GiftAddIconProps = CreateIconComponentProps;
export const GiftAddIcon: React.FC<GiftAddIconProps> = ({
  title = 'GiftAdd',
  viewBox = '0 0 24 24',
  ...rest
}) => (
  <CreateIconComponent title={title} viewBox={viewBox} {...rest} fill="none">
    <rect
      width="16.8"
      height="3.733"
      x="2.2"
      y="10.067"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      rx=".381"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M10.6 10.067V22.2M17.133 13.8v6.533c0 1.031-.835 1.867-1.866 1.867H5.933a1.867 1.867 0 0 1-1.866-1.867V13.8M6.4 10.067a2.333 2.333 0 0 1 0-4.667c1.842-.032 3.509 1.82 4.2 4.667.69-2.847 2.357-4.699 4.2-4.667a2.333 2.333 0 0 1 0 4.667M18 3.5h5M20.5 1v5"
    />
  </CreateIconComponent>
);
